export default __webpack_public_path__ + "static/media/skills.bd50e3c6.jfif";